import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslationService } from '../services/translation.service';

export let dataTranslation={
  menu: [],
  other: [],
  breadcrumb: []
};

@Pipe({
  name: 'TranslationFormat'
})

export class TranslationFormatPipe implements PipeTransform {

  protected translationService: TranslationService = inject(TranslationService);

  transform(value: string, type:string,curLang:string): string {
    var ans='';
    dataTranslation[type].forEach(element => {
          if(element.title == value){
            ans = this.translationService.getDataFromTranslations(element,'title', curLang);
          }
      });
    return ans;
  }

}
